module.exports = __webpack_public_path__ + "img/live-share.2881f6d0.png";